function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.localization-selector)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
    setTimeout(() => {
       console.log("event fired");
     window.dispatchEvent(new Event('resize'));
       }, 100);
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
     this.updateAB030ContentModal();
  }
  updateAB030ContentModal(){
      setTimeout(function(){
        if($(".custom-variant-selector-wrapper").length > 0){
          if(abtest_option_ab030_1 == 'v1'){
            console.log("Ddddddd");
             if($(".hide-default-variant-selector").length > 0){
                $(`variant-selects`).hide();
             }else{
                $("variant-selects .custom-selector-name-quantite").hide();
                $("variant-selects .product-form__input.product-form__input--dropdown div.select").css("max-width","100%");
             }
            $(`.guide-des-tailles`).hide();
             $(".custom-variant-selector-wrapper").show();
            $(`.custom-variant-selector-items[data-position="1"] input`).first().prop("checked",true).trigger("change");
          }else{
            if($('body').hasClass("hw-abt-30-1") && (abtest_option_ab030_1 == 'test')){
               if($(".hide-default-variant-selector").length > 0){
                $(`variant-selects`).hide();
               }
                $(`.guide-des-tailles`).hide();
                $(".custom-variant-selector-wrapper").show();
               $("variant-selects .custom-selector-name-quantite").hide();
                $("variant-selects .product-form__input.product-form__input--dropdown div.select").css("max-width","100%");
            }else{
              $(`variant-selects`).show();
              $(`.guide-des-tailles`).show();
              $(".custom-variant-selector-wrapper").hide();
              $("variant-selects .custom-selector-name-quantite").removeAttr('style');
              $("variant-selects .product-form__input.product-form__input--dropdown div.select").removeAttr("style");
            }
            
          }
        }
      },300);
      
    }
  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

        publish(PUB_SUB_EVENTS.variantChange, {data: {
          sectionId,
          html,
          variant: this.currentVariant
        }});
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

let lastScrollTop = 0;
let preventReveal = false;

function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}


function hideHeader() {
  const header = document.querySelector('.section-header');
  header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
  
}

function revealHeader() {
 const header = document.querySelector('.section-header');
 header.classList.add('shopify-section-header-sticky', 'animate');
 header.classList.remove('shopify-section-header-hidden');
}

function resetHeader() {
  const header = document.querySelector('.section-header');
  header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
}
function onScroll() {
  if (isIOS()) {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const headerBounds = document.querySelector('sticky-header').getBoundingClientRect();
    const header = document.querySelector('.section-header');
  
   if (scrollTop > lastScrollTop && scrollTop > headerBounds.bottom) {
        header.classList.add('scrolled-past-header');
        //header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      requestAnimationFrame(hideHeader);
    } else if (scrollTop < lastScrollTop && scrollTop > headerBounds.bottom) {
      header.classList.add('scrolled-past-header');
      //header.classList.add('shopify-section-header-sticky', 'animate');
      //header.classList.remove('shopify-section-header-hidden');
     requestAnimationFrame(revealHeader);
    } else if (scrollTop <= headerBounds.top) {
      header.classList.remove('scrolled-past-header');
      //header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      requestAnimationFrame(resetHeader);
    }
  lastScrollTop = scrollTop;
  }
}

// Attach the onScroll function to the scroll event
window.addEventListener('scroll', onScroll);

const initializeBodyObservation=()=>{const t=document.body;new MutationObserver((function(e,i){for(const i of e)"attributes"===i.type&&"class"===i.attributeName&&(t.classList.contains("hw-abt-16-1")&&(reinitilizeSwiperVideoSlider(),window.dispatchEvent(new Event("resize"))),t.classList.contains("hw-abt-23-1")&&(egswiperTiktok=new Swiper(".product_composition_wrapper .swiper-container",{direction:"horizontal",spaceBetween:20,slidesPerView:4,loop:!1,roundLengths:!0,clickable:!1,breakpoints:{991:{slidesPerView:1,loop:!0}},pagination:{el:".product_pagination",clickable:!0},navigation:{nextEl:".swiper-button-next",prevEl:".swiper-button-prev"}})),t.classList.contains("hw-abt-23-2")&&(egswiperTiktok=new Swiper(".product_composition_wrapper .swiper-container",{direction:"horizontal",spaceBetween:20,slidesPerView:4,loop:!1,roundLengths:!0,clickable:!1,breakpoints:{991:{slidesPerView:1,loop:!0}},pagination:{el:".product_pagination",clickable:!0},navigation:{nextEl:".swiper-button-next",prevEl:".swiper-button-prev"}})),(t.classList.contains("hw-abt-29-1")||t.classList.contains("hw-abt-29-2"))&&change_checkoutbtn_text(),updateAb019Layout())})).observe(t,{attributes:!0})};function addScript(){var t=document.createElement("script");t.src="https://cdnjs.cloudflare.com/ajax/libs/Swiper/4.0.7/js/swiper.min.js",document.getElementsByTagName("head")[0].appendChild(t)}function getOptionSelectedString(t){let e=[];return t.find(".custom-swatch .custom-swatch-element .mark_me-custom:checked").each((function(){e.push($(this).val())})),e}function getCustomSelectorOptionMap(t){let e=[];return t.find(".mark_me-custom-bundle:checked").length>0&&e.push(t.find(".mark_me-custom-bundle:checked").val()),t.find(".custom-option-selector").each((function(){e.push($(this).val())})),e}async function updateSimpleProgressbar(){document.querySelectorAll(".custom-cart-gift-item-template").length>0&&document.querySelectorAll(".cart-simple-progressbar-placement-wrapper").length>0&&document.querySelectorAll(".cart-simple-progressbar-placement-wrapper .custom-cart-gift-item-template").length<=0&&(document.querySelector(".cart-simple-progressbar-placement-wrapper").innerHTML=document.querySelector(".custom-cart-gift-item-template").innerHTML),console.log("ddd","dd"),change_checkoutbtn_text()}function reinitilizeSwiperVideoSlider(){const t=document.querySelector(".eg-video-section-inr .swiper-container").swiper;if(t){t.destroy();new Swiper(".eg-video-section .swiper-container",{direction:"horizontal",spaceBetween:20,slidesPerView:4,roundLengths:!0,loop:!0,breakpoints:{1199:{slidesPerView:3.3},991:{slidesPerView:3.3},800:{slidesPerView:2.6},576:{slidesPerView:1.3}},pagination:{el:".slider__pagination",clickable:!0},navigation:{nextEl:".swiper-button-next",prevEl:".swiper-button-prev"}})}}window.addEventListener("popstate",(function(t){t.state&&t.state.pageReload&&window.location.reload()})),waitForSwiper=function(t){var e=setInterval((function(){"undefined"!=typeof Swiper&&(clearInterval(e),t())}),50);setTimeout((function(){clearInterval(e)}),15e3)},document.addEventListener("DOMContentLoaded",(t=>{document.addEventListener("load_simple_progressbar",updateSimpleProgressbar),initializeBodyObservation(),$(document).on("click","#checkout-2",(function(t){return t.stopImmediatePropagation(),t.preventDefault(),t.stopPropagation(),window.location.href="/checkout",!1})),$(document).on("click","#CartDrawer-Checkout-2",(function(t){return t.stopImmediatePropagation(),t.preventDefault(),t.stopPropagation(),history.pushState({pageReload:!0},""),window.location.href="/checkout",!1})),1==history.state?.pageReload&&(history.pushState({pageReload:!1},""),window.location.reload(!0));const e=setInterval((()=>{document.querySelectorAll("#tidio-chat iframe").length>0&&(document.querySelector("#tidio-chat iframe").style.zIndex="100",clearInterval(e))}),500);if($(document).on("click",".eg-crossSell_add-item",(function(){const t=$(this).data("id"),e=$(this),i=document.querySelector("cart-notification")||document.querySelector("cart-drawer");e.addClass("loading"),e.find(".loading-overlay__spinner").removeClass("hidden"),document.querySelectorAll("#CartDrawer-Checkout-2").length>0&&document.querySelector("#CartDrawer-Checkout-2").setAttribute("disabled","disabled");let o={items:[{id:t,quantity:1}],sections:i.getSectionsToRender().map((t=>t.id)),sections_url:window.location.pathname};fetch(`${routes.cart_add_url}.js`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(o)}).then((t=>t.json())).then((e=>{e.status?publish(PUB_SUB_EVENTS.cartError,{source:"product-form",productVariantId:t,errors:e.description,message:e.message}):i?(publish(PUB_SUB_EVENTS.cartUpdate,{source:"product-form",productVariantId:t}),i.renderContents(e)):window.location=window.routes.cart_url})).catch((t=>{console.error(t)})).finally((()=>{document.querySelectorAll("#CartDrawer-Checkout-2").length>0&&document.querySelector("#CartDrawer-Checkout-2").removeAttribute("disabled")}))})),$(document).on("change",".eg-option-select-patch",(function(t){t.preventDefault(),t.stopPropagation(),t.stopImmediatePropagation();const e=$(this).val(),i=$(this).parents(".eg-crossSell_item");i.find(".eg-crossSell_add-item").attr("data-id",e),i.find(".eg-crossSell_item-content_header_price").addClass("hidden"),i.find(`.eg-crossSell_item-content_header_price[data-vaiantid="${e}"]`).removeClass("hidden"),i.find(".custom-variant-image").addClass("hidden"),i.find(`.custom-variant-image[data-vid="${e}"]`).removeClass("hidden")})),$(document).on("click",".custom-filter-box ",(function(){$(".custom-filter-box").removeClass("active"),$(this).addClass("active");const t=$(this).data("id"),e=$(this).hasClass("first-class");$(".filter-items").each((function(){e?$(".filter-items").removeClass("hide").slideDown():$(this).attr("id")!=t?($that=$(this),$(this).slideUp((function(){$that.addClass("hide")}))):($(this).removeClass("hide"),$(this).slideDown())}))})),$(document).on("click",".custom-quick-add__submit",(function(t){t.preventDefault(),t.stopPropagation(),$(".custom-modal__centered.active").removeClass("active");const e=$(this).data("id");let i;$(`.custom-modal__centered[data-id="${e}"]`).addClass("active"),$("body").addClass("remove-zindex"),i&&i.destroy(),i=OverlayScrollbars(document.querySelector(`.custom-modal__centered[data-id="${e}"] div.product-bundle-items-wrapper`),{overflow:{x:"hidden",y:"scroll"}})})),$(document).on("click","button.custom-modal__close",(function(){$(".custom-modal__centered.active").removeClass("active"),$("body").removeClass("remove-zindex")})),$(document).on("change",".mark_me-custom",(async function(){const t=$(this).parents(".custom-swatches-new"),e=await getOptionSelectedString(t);if($div=$(this).parent(),$div.hasClass("color-swatch")&&t.find(".custom-color-name-placement").text($div.data("value")),e.length>0){const i=e.join("-"),o=jQuery(this).closest("form");if(t.find(`div.varaint-template-data div[data-option="${i}"]`).length>0){const e=t.find(`div.varaint-template-data div[data-option="${i}"]`).data("vid"),s=t.find(`div.varaint-template-data div[data-option="${i}"]`).data("saving"),r=t.find(`div.varaint-template-data div[data-option="${i}"] input`).data("available");o.find(".cv__bf-bundle-savedPrice").text(s),o.find("select.select__select").val(e).prop("selected","selected").trigger("change"),1==r?(o.find("button.quick-add__submit .addtocart-message").removeClass("hidden"),o.find("button.quick-add__submit .sold-out-message").addClass("hidden"),o.find("button.quick-add__submit").removeAttr("disabled")):(o.find("button.quick-add__submit .addtocart-message").addClass("hidden"),o.find("button.quick-add__submit .sold-out-message").removeClass("hidden"),o.find("button.quick-add__submit").attr("disabled","disabled"))}else o.find("button.quick-add__submit").attr("disabled","disabled")}})),$(document).on("change",".mark_me-custom-bundle",(async function(){const t=$(this).parents(".custom-swatches-bundle-new"),e=await getCustomSelectorOptionMap(t),i=$(this).data("image");if($(this).parents(".product-bundle-items-wrapper-free").length>0){const t=$(this).parents(".product-bundle-item-wrapper-free");""!=i&&(t.find(".product-bundle-item-image .motion-reduce").addClass("hidden"),t.find(`.product-bundle-item-image .motion-reduce[data-imageid="${i}"]`).removeClass("hidden"))}else{const t=$(this).parents(".product-bundle-item-wrapper");""!=i&&(t.find(".product-bundle-item-image .motion-reduce").addClass("hidden"),t.find(`.product-bundle-item-image .motion-reduce[data-imageid="${i}"]`).removeClass("hidden"))}if(e.length>0){const i=e.join("-"),o=t.parents(".product-bundle-item-content");if(t.find(`div.varaint-template-data div[data-option="${i}"]`).length>0){const e=t.find(`div.varaint-template-data div[data-option="${i}"]`).data("vid"),s=t.find(`div.varaint-template-data div[data-option="${i}"]`).data("vtitle");o.find(".custom-qty-box-input").attr("data-vid",e),o.find(".custom-qty-box-input").attr("data-title",s),$(this).parents('div.product-bundle-items-wrapper-free[data-size="1"]').length>0&&o.find(".quantity-button-free.plus-free").trigger("click"),$(this).parents(".product-bundle-items-wrapper-simple-pack").length>0&&(o.find(".custom-qty-box-input").val(o.find(".custom-qty-box-input").data("quantity")),o.find(".custom-qty-box-input").addClass("active"),o.find(".quantity-button.plus").trigger("click"))}}})),$(document).on("change",".custom-option-selector",(async function(){const t=$(this).parents(".custom-swatches-bundle-new"),e=await getCustomSelectorOptionMap(t);if(e.length>0){const i=e.join("-"),o=t.parents(".product-bundle-item-content");if(t.find(`div.varaint-template-data div[data-option="${i}"]`).length>0){const e=t.find(`div.varaint-template-data div[data-option="${i}"]`).data("vid"),s=(t.find(`div.varaint-template-data div[data-option="${i}"] input`).data("available"),t.find(`div.varaint-template-data div[data-option="${i}"]`).data("vtitle"));o.find(".custom-qty-box-input").attr("data-vid",e),o.find(".custom-qty-box-input").attr("data-title",s),$(this).parents('div.product-bundle-items-wrapper-free[data-size="1"]').length>0&&o.find(".quantity-button-free.plus-free").trigger("click"),$(this).parents(".product-bundle-items-wrapper-simple-pack").length>0&&(o.find(".custom-qty-box-input").val(o.find(".custom-qty-box-input").data("quantity")),o.find(".custom-qty-box-input").addClass("active"),o.find(".quantity-button.plus").trigger("click"))}else if($(this).parents(".product-bundle-items-wrapper-simple-pack").length>0&&(o.find(".custom-qty-box-input").val(-1),o.find(".custom-qty-box-input").removeClass("active"),o.find(".quantity-button.plus").trigger("click")),$(this).parents("div.product-bundle-items-wrapper-free").length<=0&&$(this).parents("product-bundle-form").length>0){const t=$(this).parents("product-bundle-form")[0];t.quantityCounter=t.quantityCounter-o.find(".custom-qty-box-input").val(),t.quantityCounter=t.quantityCounter+1,o.find(".custom-qty-box-input").val(1),o.find(".quantity-button.minus").trigger("click")}}})),$(document).on("click",".collection-custom-swatches button.color-swatch",(function(){$div=$(this).parent(".collection-custom-swatches"),$div.find("button.color-swatch").removeClass("active"),$(this).addClass("active");const t=$(this).data("value");let e=`.custom-swatches-new[data-id="${$div.data("id")}"]`;$(e).length>0&&(selectedColor=$(e).find(`.color-swatch-main-wrapper .mark_me-custom[value="${t}"]`).prop("checked",!0).trigger("change"));const i=$(this).parents(".product-card-wrapper");i.find("img.cp-swatch-image").addClass("hidden"),i.find("img.orignal-image").removeClass("hidden"),i.find("img.cp-swatch-image").each((function(){null!=$(this).attr("src").match(`${t}`)&&$(this).attr("src").match(`${t}`).length>0&&($(this).removeClass("hidden"),i.find("img.orignal-image").addClass("hidden"))}))})),$(document).on("click",".custom-product-page-bundle-wrapper-button-wrapper button",(function(){$(".custom-product-page-bundle-wrapper-button-wrapper").addClass("hidden"),$(".custom-product-page-bundle-wrapper").removeClass("hidden")})),$(".custom-collecton-slider-home-page .eg-carousel").length>0&&($(document).on("click",".tab-handler",(function(){const t=$(this).data("tabopner");$(".story-card").removeClass("eg-active"),$(this).parent(".story-card").addClass("eg-active");const e=document.querySelector(".story-card.eg-active");let i=e.offsetWidth;document.querySelector(".eg-tabs-nav__position").style.cssText="--width:"+i+"px;--prevWidth:"+e.offsetLeft+"px;",e.scrollIntoView({behavior:"smooth",block:"nearest",inline:"center"}),$(".custom-collecton-slider-home-page .eg-carousel").removeClass("eg-active"),$(`.custom-collecton-slider-home-page #${t}`).addClass("eg-active"),$(`.custom-collecton-slider-home-page #${t}`).not(".no-slider").slick("refresh")})),$(".custom-collecton-slider-home-page .eg-carousel").not(".no-slider").slick({initialSlide:0,slidesToScroll:4,slidesToShow:4,arrows:!0,dots:!1,speed:300,infinite:!1,responsive:[{breakpoint:1200,settings:{slidesToShow:3,slidesToScroll:3}},{breakpoint:767,settings:{slidesToShow:2,slidesToScroll:2}}]})),$(".custom-collecton-slider-collection-page").length>0&&$(".custom-collecton-slider-collection-page .story-card.eg-active").length>0){const t=document.querySelector(".custom-collecton-slider-collection-page .story-card.eg-active");let e=t.offsetWidth;document.querySelector(".eg-tabs-nav__position").style.cssText="--width:"+e+"px;--prevWidth:"+t.offsetLeft+"px;",t.scrollIntoView({behavior:"smooth",block:"nearest",inline:"center"})}"undefined"==typeof Swiper&&addScript();var i=document.querySelector(".custom-megamenu header-menu details"),o=document.body;document.querySelectorAll(".custom-megamenu header-menu details summary").length>0&&document.querySelector(".custom-megamenu header-menu details summary").dispatchEvent(new Event("click")),i.addEventListener("mouseenter",(function(){o.classList.add("eg-overlay-active")})),i.addEventListener("mouseleave",(function(){o.classList.remove("eg-overlay-active")})),waitForSwiper((function(){new Swiper(".eg-mobile-bar .swiper-container",{direction:"horizontal",slidesPerView:"3.5",roundLengths:!0,loop:!1});new Swiper(".eg-video-section .swiper-container",{direction:"horizontal",spaceBetween:20,slidesPerView:4,roundLengths:!0,loop:!0,breakpoints:{1199:{slidesPerView:3.3},991:{slidesPerView:3.3},800:{slidesPerView:2.6},576:{slidesPerView:1.3}},pagination:{el:".slider__pagination",clickable:!0},navigation:{nextEl:".swiper-button-next",prevEl:".swiper-button-prev"}});document.querySelectorAll(".eg-video-section .swiper-container .swiper-slide").forEach((function(t){t.addEventListener("click",(function(){this.classList.contains("active")?(this.querySelector("video").pause(),this.classList.remove("active")):(document.querySelector(".swiper-slide.active")&&(document.querySelector(".swiper-slide.active").querySelector("video").pause(),document.querySelector(".swiper-slide.active").classList.remove("active")),this.querySelector("video").play(),this.classList.add("active"))}))})),window.dispatchEvent(new Event("resize"))}))})),window.onload=function(){window.dispatchEvent(new Event("resize"))};class CountdownTimer extends HTMLElement{constructor(){super(),this.endTime=new Date(this.getAttribute("end-date")).getTime()}updateCountdown(){const t=(new Date).getTime(),e=this.endTime-t;if(e<=0)this.style.display="none",document.querySelector(".countdown-wrapper").style.display="none";else{Math.floor(e/864e5);const t=Math.floor(e%864e5/36e5),i=Math.floor(e%36e5/6e4),o=Math.floor(e%6e4/1e3);this.querySelector(".hours-counter").innerHTML=String(t).padStart(2,"0"),this.querySelector(".minutes-counter").innerHTML=String(i).padStart(2,"0"),this.querySelector(".seconds-counter").innerHTML=String(o).padStart(2,"0")}}addHTML(){this.innerHTML=`\n        <div class="timer-item days-item"><span class="days-counter">${String(0).padStart(2,"0")}</span><span class="small-size">JOURS</span></div>\n        <div class="timer-item hours-item"><span class="hours-counter">${String(0).padStart(2,"0")}</span><span class="small-size">HEURES</span></div>\n        <div class="timer-item minutes-item"><span class="minutes-counter">${String(0).padStart(2,"0")}</span><span class="small-size">MINUTES</span></div>\n        <div class="timer-item seconds-items"><span class="seconds-counter">${String(0).padStart(2,"0")}</span><span class="small-size">SECONDES</span></div>`}connectedCallback(){this.addHTML(),this.updateCountdown(),this.interval=setInterval((()=>this.updateCountdown()),1e3)}disconnectedCallback(){clearInterval(this.interval)}}customElements.define("countdown-timer",CountdownTimer);class CustomCountdownTimer extends HTMLElement{constructor(){super(),this.shadow=this.attachShadow({mode:"open"}),this.countdownElement=null}connectedCallback(){this.timezone=this.getAttribute("timezone")||"UTC",this.endDate=new Date(this.getAttribute("end-date")),this.render(),this.updateCountdown(),this.interval=setInterval((()=>this.updateCountdown()),1e3)}render(){this.shadow.innerHTML='\n        <div id="countdown"></div>\n      ',this.countdownElement=this.shadow.getElementById("countdown")}updateCountdown(){const t=new Date,e=new Date(this.endDate)-new Date(t);if(e>0){let t=Math.floor(e%864e5/36e5),i=Math.floor(e%36e5/6e4),o=Math.floor(e%6e4/1e3);t<10&&(t=`0${t}`),i<10&&(i=`0${i}`),o<10&&(o=`0${o}`),this.countdownElement.textContent=`${t}:${i}:${o}`}else this.closest(".simple-bar-wrapper")&&(this.closest(".simple-bar-wrapper").style.display="none"),clearInterval(this.interval)}}function startTimer(t){timeInSecs=parseInt(t),ticker=setInterval("tick()",1e3)}function tick(){var t,e=timeInSecs;e>0?timeInSecs--:(clearInterval(ticker),startTimer(600));Math.floor(e/86400);e%=86400;Math.floor(e/3600);e%=3600;var i=Math.floor(e/60);t=(i<10?"0":"")+i+":"+((e%=60)<10?"0":"")+e;var o=document.getElementById("carttimer");o&&(o.innerHTML=t)}var timeInSecs,ticker;function cartHideActionButtons(){document.querySelectorAll("#CartDrawer-Checkout-2").length>0&&(document.querySelector("#CartDrawer-Checkout-2").setAttribute("disabled","disabled"),document.querySelector("#CartDrawer-Checkout-2").classList.add("hidden")),document.querySelectorAll("#checkout-2").length>0&&(document.querySelector("#checkout-2").setAttribute("disabled","disabled"),document.querySelector("#checkout-2").classList.add("hidden")),document.querySelectorAll("#cart-notification-button").length>0&&(document.querySelector("#cart-notification-button").setAttribute("disabled","disabled"),document.querySelector("#cart-notification-button").classList.add("hidden"))}let staticInterval,egswiperTiktok;async function cartDisplayActionButtons(){const t=document.querySelector("simple-progress-bar");if(t){const e=await fetch("/cart.js"),i=await e.json(),o=+t.threshold;i.items.filter((t=>1==t.properties._isGift)).length>0?i.total_price>o?setTimeout((function(){document.querySelectorAll("#CartDrawer-Checkout-2").length>0&&(document.querySelector("#CartDrawer-Checkout-2").removeAttribute("disabled"),document.querySelector("#CartDrawer-Checkout-2").classList.remove("hidden")),document.querySelectorAll("#checkout-2").length>0&&(document.querySelector("#checkout-2").removeAttribute("disabled"),document.querySelector("#checkout-2").classList.remove("hidden")),document.querySelectorAll("#cart-notification-button").length>0&&(document.querySelector("#cart-notification-button").removeAttribute("disabled"),document.querySelector("#cart-notification-button").classList.remove("hidden"))}),50):cartHideActionButtons():(document.querySelectorAll("#CartDrawer-Checkout-2").length>0&&(document.querySelector("#CartDrawer-Checkout-2").removeAttribute("disabled"),document.querySelector("#CartDrawer-Checkout-2").classList.remove("hidden")),document.querySelectorAll("#checkout-2").length>0&&(document.querySelector("#checkout-2").removeAttribute("disabled"),document.querySelector("#checkout-2").classList.remove("hidden")),document.querySelectorAll("#cart-notification-button").length>0&&(document.querySelector("#cart-notification-button").removeAttribute("disabled"),document.querySelector("#cart-notification-button").classList.remove("hidden")))}else document.querySelectorAll("#CartDrawer-Checkout-2").length>0&&(document.querySelector("#CartDrawer-Checkout-2").removeAttribute("disabled"),document.querySelector("#CartDrawer-Checkout-2").classList.remove("hidden")),document.querySelectorAll("#checkout-2").length>0&&(document.querySelector("#checkout-2").removeAttribute("disabled"),document.querySelector("#checkout-2").classList.remove("hidden")),document.querySelectorAll("#cart-notification-button").length>0&&(document.querySelector("#cart-notification-button").removeAttribute("disabled"),document.querySelector("#cart-notification-button").classList.remove("hidden"))}function waitForElement(t,e,i,o){var s=setInterval((function(){document&&document.querySelector(t)&&document.querySelectorAll(t).length>0&&(clearInterval(s),e())}),i);setTimeout((function(){clearInterval(s)}),o)}function removeParentheses(t){return t.replace(/[()]/g,"")}customElements.define("custom-countdown",CustomCountdownTimer),customElements.get("simple-progress-bar")||customElements.define("simple-progress-bar",class extends HTMLElement{constructor(){super();this.threshold=+this.dataset.threshold,this.freeProductID=this.dataset.productid,this.selectors={progressBar1:"#progressbar1"},this.isAddedGift=!1,this.freegiftKey="",this.secondenabled=this.dataset.secondenabled,this.threshold2=+this.dataset.threshold2,this.freeProductID2=this.dataset.productid2,this.matchedOnCart=[],this.matchedOnCart2=[],this.totalMatchedCart=[],this.secondGifItems=[],this.firstGifItems=[],this.cart=document.querySelector("cart-notification")||document.querySelector("cart-drawer"),this.cartItems=document.querySelector("cart-items")||document.querySelector("cart-drawer-items"),this.productIds=[],this.init()}calculatePercentage(t,e,i){let o=0;return t<=e?o=t/e*60:t>e&&t<=i?(o=70+(t-e)/(i-e)*20,o=Math.min(Math.max(75,o),82)):t>i&&(o=100),o}async init(){if(1==this.secondenabled){this.secondGifItems=[],this.firstGifItems=[],""!=this.freeProductID&&(this.firstGifItems=this.freeProductID.split("___")),""!=this.freeProductID2&&(this.secondGifItems=this.freeProductID2.split("___"));let t=this.querySelector(this.selectors.progressBar1);const e=await fetch("/cart.js"),i=await e.json();let o=0;const s=i.items.filter((t=>this.firstGifItems.includes(`${t.id}`)&&1==t.properties._isGift));if(s.length>0){this.matchedOnCart=s;for(let t in s)o+=s[t].final_line_price,this.totalMatchedCart.push(s[t])}const r=i.items.filter((t=>this.secondGifItems.includes(`${t.id}`)&&1==t.properties._isGift));if(r.length>0){this.matchedOnCart2=r;for(let t in r)o+=r[t].final_line_price,this.totalMatchedCart.push(r[t])}const n=i.total_price-o,a=n/100;let c=n/100,d=c/this.threshold2*100;if(d=this.calculatePercentage(c,this.threshold,this.threshold2),a>=this.threshold2){if(this.firstGifItems.length>0&&s.length<=0)for(let t in this.firstGifItems)this.productIds.push(this.firstGifItems[t]);if(this.secondGifItems.length>0&&r.length<=0)for(let t in this.secondGifItems)this.productIds.push(this.secondGifItems[t]);if(r.length<=0&&""!=this.freeProductID2){this.addRemoveGiftMultiple(1,0);const t=this.querySelector(".first-threshold .position-bar-box-container .bar-icon-wrapper");this.progressConfetti(t);const e=this.querySelector(".second-threshold .position-bar-box-container .bar-icon-wrapper");this.progressConfetti(e)}}else if(a>=this.threshold&&a<this.threshold2){if(r.length>0&&this.secondGifItems.length>0&&this.addRemoveGiftMultiple(0,1),s.length<=0&&this.firstGifItems.length>0){this.productIds=[];for(let t in this.firstGifItems)this.productIds.push(this.firstGifItems[t]);this.addRemoveGiftMultiple(1,0);const t=this.querySelector(".first-threshold .position-bar-box-container .bar-icon-wrapper");this.progressConfetti(t)}}else a<this.threshold&&r.length>0&&s.length>0&&this.addRemoveGiftMultiple(0,2);if(c<this.threshold){this.querySelector(".first-thrshold-content-div").classList.remove("hidden"),this.querySelector(".first-threshold .position-bar-box-container").classList.remove("activated-gift"),this.querySelector(".first-thrshold-content-div .threshold-text-content.success-message").classList.add("hidden"),this.querySelector(".first-thrshold-content-div .threshold-text-content.threshold-before-message").classList.remove("hidden"),this.querySelector(".second-thrshold-content-div").classList.add("hidden"),this.querySelector(".second-threshold .position-bar-box-container").classList.remove("activated-gift"),this.querySelector(".second-thrshold-content-div .threshold-text-content.success-message").classList.add("hidden"),this.querySelector(".second-thrshold-content-div .threshold-text-content.threshold-before-message").classList.add("hidden");const t=100*this.threshold-n;this.querySelector(".first-thrshold-content-div .threshold-text-content.threshold-before-message .custom-amount").textContent=Shopify.formatMoney(t)}else if(c>=this.threshold&&c<this.threshold2){this.querySelector(".first-thrshold-content-div").classList.add("hidden"),this.querySelector(".first-threshold .position-bar-box-container").classList.add("activated-gift"),this.querySelector(".first-thrshold-content-div .threshold-text-content.success-message").classList.remove("hidden"),this.querySelector(".first-thrshold-content-div .threshold-text-content.threshold-before-message").classList.add("hidden"),this.querySelector(".second-thrshold-content-div").classList.remove("hidden"),this.querySelector(".second-threshold .position-bar-box-container").classList.remove("activated-gift"),this.querySelector(".second-thrshold-content-div .threshold-text-content.success-message").classList.add("hidden"),this.querySelector(".second-thrshold-content-div .threshold-text-content.threshold-before-message").classList.remove("hidden");const t=100*this.threshold2-n;if(this.querySelector(".second-thrshold-content-div .threshold-text-content.threshold-before-message .custom-amount")){this.querySelector(".second-thrshold-content-div .threshold-text-content.threshold-before-message .custom-amount").textContent = Shopify.formatMoney(t)
}}else c>=this.threshold2&&(this.querySelector(".first-thrshold-content-div").classList.add("hidden"),this.querySelector(".first-threshold .position-bar-box-container").classList.add("activated-gift"),this.querySelector(".first-thrshold-content-div .threshold-text-content.success-message").classList.remove("hidden"),this.querySelector(".first-thrshold-content-div .threshold-text-content.threshold-before-message").classList.add("hidden"),this.querySelector(".second-thrshold-content-div").classList.remove("hidden"),this.querySelector(".second-threshold .position-bar-box-container").classList.add("activated-gift"),this.querySelector(".second-thrshold-content-div .threshold-text-content.success-message").classList.remove("hidden"),this.querySelector(".second-thrshold-content-div .threshold-text-content.threshold-before-message").classList.add("hidden"));document.querySelectorAll("#progressbar-custom-element").length>0&&document.querySelector("#progressbar-custom-element").remove(),t.style.width=`${d}%`}else{""!=this.freeProductID&&(this.productIds=this.freeProductID.split("___"));let t=this.querySelector(this.selectors.progressBar1);const e=await fetch("/cart.js"),i=await e.json();let o=0;const s=i.items.filter((t=>this.productIds.includes(`${t.id}`)&&1==t.properties._isGift));if(s.length>0){this.matchedOnCart=s;for(let t in s)o+=s[t].final_line_price}if(s.length>0&&1==i.item_count)return void this.addRemoveGiftMultiple(0,0);const r=100*this.threshold,n=i.total_price-o,a=r-n;let c=(n/100/this.threshold*100).toFixed(2);if(r<=n){if(this.querySelector(".position-bar-box-container").classList.add("activated-gift"),s.length<=0){const t=this.querySelector(".position-bar-box-container .bar-icon-wrapper");this.progressConfetti(t),this.addRemoveGiftMultiple(1,0)}c=100,this.querySelector(".threshold-text-content.success-message").classList.remove("hide"),this.querySelector(".threshold-text-content.threshold-before-message").classList.add("hide")}else s.length>0&&this.addRemoveGiftMultiple(0,0),this.querySelector(".position-bar-box-container").classList.remove("activated-gift"),this.querySelector(".threshold-text-content.success-message").classList.add("hide"),this.querySelector(".threshold-text-content.threshold-before-message").classList.remove("hide"),this.querySelector(".threshold-text-content.threshold-before-message .custom-amount").textContent=Shopify.formatMoney(a),c>70&&c<=85?c=70:c>85&&(c=75.5);document.querySelectorAll("#progressbar-custom-element").length>0&&document.querySelector("#progressbar-custom-element").remove(),t.style.width=`${c}%`}}progressConfetti(t){var e=document.createElement("canvas"),i=t;e.width=600,e.height=600,i.appendChild(e);var o=confetti.create(e);o({particleCount:200,spread:200,startVelocity:15,scalar:.9,ticks:90}),o().then((function(){i.removeChild(e)}))}addRemoveGiftMultiple(t,e){if(!(this.productIds.length<=0&&t>0))if(t>0){let t=[];t=this.productIds.map((t=>({id:t,quantity:1,properties:{_isGift:1}}))),cartHideActionButtons();let e={items:t,sections:this.cart.getSectionsToRender().map((t=>t.id)),sections_url:window.location.pathname};fetch(`${routes.cart_add_url}.js`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(e)}).then((t=>t.json())).then((t=>{"/cart"!=window.location.pathname?t.status?publish(PUB_SUB_EVENTS.cartError,{source:"product-form",productVariantId:this.freeProductID,errors:t.description,message:t.message}):this.cart?(publish(PUB_SUB_EVENTS.cartUpdate,{source:"product-form",productVariantId:this.freeProductID}),this.cart.renderContents(t)):window.location=window.routes.cart_url:fetch(`${routes.cart_url}?section_id=main-cart-items`).then((t=>t.text())).then((t=>{const e=(new DOMParser).parseFromString(t,"text/html").querySelector("cart-items");document.querySelector("cart-items").innerHTML=e.innerHTML})).catch((t=>{console.error(t)})).finally((()=>{cartDisplayActionButtons()}))})).catch((t=>{console.error(t)})).finally((()=>{this.cart&&this.cart.classList.contains("is-empty")&&this.cart.classList.remove("is-empty"),cartDisplayActionButtons()}))}else{let t;console.log(e,this.matchedOnCart2,1120),cartHideActionButtons(),t=2==e?this.totalMatchedCart.reduce(((t,{key:e,quantity:i})=>(t[e]=0,t)),{}):1==e?this.matchedOnCart2.reduce(((t,{key:e,quantity:i})=>(t[e]=0,t)),{}):this.matchedOnCart.reduce(((t,{key:e,quantity:i})=>(t[e]=0,t)),{});const i=JSON.stringify({updates:t,sections:this.cart.getSectionsToRender().map((t=>t.id)),sections_url:window.location.pathname});fetch(`${routes.cart_update_url}.js`,{method:"POST",headers:{"Content-Type":"application/json"},body:i}).then((t=>t.json())).then((t=>{if("/cart"==window.location.pathname)return void fetch(`${routes.cart_url}?section_id=main-cart-items`).then((t=>t.text())).then((t=>{const e=(new DOMParser).parseFromString(t,"text/html").querySelector("cart-items");document.querySelector("cart-items").innerHTML=e.innerHTML})).catch((t=>{console.error(t)})).finally((()=>{cartDisplayActionButtons()}));if(!this.cart)return void(window.location=window.routes.cart_url);const e=document.querySelector("cart-drawer");e&&e.classList.toggle("is-empty",0===t.item_count),this.cart.renderContents(t),cartDisplayActionButtons()}))}}addRemoveGift(t){if(""==this.freeProductID)return;let e=[{id:this.freeProductID,quantity:1,properties:{_isGift:1}}];if(t>0){cartHideActionButtons();let t={items:e,sections:this.cart.getSectionsToRender().map((t=>t.id)),sections_url:window.location.pathname};fetch(`${routes.cart_add_url}.js`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(t)}).then((t=>t.json())).then((t=>{"/cart"!=window.location.pathname?t.status?publish(PUB_SUB_EVENTS.cartError,{source:"product-form",productVariantId:this.freeProductID,errors:t.description,message:t.message}):this.cart?(publish(PUB_SUB_EVENTS.cartUpdate,{source:"product-form",productVariantId:this.freeProductID}),this.cart.renderContents(t)):window.location=window.routes.cart_url:fetch(`${routes.cart_url}?section_id=main-cart-items`).then((t=>t.text())).then((t=>{const e=(new DOMParser).parseFromString(t,"text/html").querySelector("cart-items");document.querySelector("cart-items").innerHTML=e.innerHTML})).catch((t=>{console.error(t)})).finally((()=>{cartDisplayActionButtons()}))})).catch((t=>{console.error(t)})).finally((()=>{this.cart&&this.cart.classList.contains("is-empty")&&this.cart.classList.remove("is-empty"),cartDisplayActionButtons()}))}else{cartHideActionButtons();const t={id:this.freegiftKey,quantity:0,sections:this.cart.getSectionsToRender().map((t=>t.id)),sections_url:window.location.pathname};fetch(`${routes.cart_change_url}.js`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(t)}).then((t=>t.json())).then((t=>{if("/cart"==window.location.pathname)return void fetch(`${routes.cart_url}?section_id=main-cart-items`).then((t=>t.text())).then((t=>{const e=(new DOMParser).parseFromString(t,"text/html").querySelector("cart-items");document.querySelector("cart-items").innerHTML=e.innerHTML})).catch((t=>{console.error(t)})).finally((()=>{cartDisplayActionButtons()}));if(!this.cart)return void(window.location=window.routes.cart_url);const e=document.querySelector("cart-drawer");e&&e.classList.toggle("is-empty",0===t.item_count),this.cart.renderContents(t),cartDisplayActionButtons()}))}}}),startTimer(600),Shopify.formatMoney=function(t,e){"string"==typeof t&&(t=t.replace(".",""));var i="",o=/\{\{\s*(\w+)\s*\}\}/,s=e||this.money_format;function r(t,e){return void 0===t?e:t}function n(t,e,i,o){if(e=r(e,2),i=r(i,","),o=r(o,"."),isNaN(t)||null==t)return 0;var s=(t=(t/100).toFixed(e)).split(".");return s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+i)+(s[1]?o+s[1]:"")}switch(s.match(o)[1]){case"amount":i=n(t,2);break;case"amount_no_decimals":i=n(t,0);break;case"amount_with_comma_separator":i=n(t,2,".",",");break;case"amount_no_decimals_with_comma_separator":i=n(t,0,".",",")}return s.replace(o,i)},document.addEventListener("DOMContentLoaded",(t=>{$(".eg-slick-slider-images").not(".slick-initialized").slick({centerMode:!1,dots:!0,speed:4e3,autoplay:!0,autoplaySpeed:10,cssEase:"linear",slidesToShow:1,draggable:!1,variableWidth:!0,responsive:[{breakpoint:991,settings:{slidesToShow:4,slidesToScroll:1,centerMode:!1,infinite:!0,dots:!0,speed:4e3,autoplay:!0,autoplaySpeed:10,cssEase:"linear",slidesToShow:1,variableWidth:!0,centerMode:!0,slidesToScroll:2}},{breakpoint:600,settings:{slidesToShow:1.925,centerMode:!1,slidesToScroll:1,speed:4e3,autoplay:!0,autoplaySpeed:10,cssEase:"linear",variableWidth:!0,centerMode:!0}},{breakpoint:480,settings:{slidesToShow:1.925,speed:4e3,autoplay:!0,autoplaySpeed:10,cssEase:"linear",slidesToShow:1,slidesToScroll:1,variableWidth:!0,centerMode:!0,slidesToScroll:2}}]}),waitForElement(".loox-rating  .loox-rating-label",(function(){document.querySelectorAll(".loox-rating  .loox-rating-label").forEach((t=>{t.textContent=removeParentheses(t.textContent)}))}),50,15e3),egswiperTiktok=new Swiper(".product_composition_wrapper .swiper-container",{direction:"horizontal",spaceBetween:20,slidesPerView:4,roundLengths:!0,clickable:!1,breakpoints:{991:{slidesPerView:1,loop:!0}},pagination:{el:".product_pagination",clickable:!0},navigation:{nextEl:".swiper-button-next",prevEl:".swiper-button-prev"}}),window.dispatchEvent(new Event("resize"))}));let isResizeedGrid=!1;function change_checkoutbtn_text(){$(".cart__checkout-button-2.v1").length>0||$("body.hw-abt-29-1").length>0?$(".cart__checkout-button-2").text("PASSER MA COMMANDE"):($(".cart__checkout-button-2.v2").length>0||$("body.hw-abt-29-2").length>0)&&$(".cart__checkout-button-2").text("VALIDER MON PANIER")}function updateAb019Layout(){$("body").hasClass("hw-abt-30 overflow-hidden")||($("body").hasClass("custom-body-product")?(($("body").hasClass("hw-abt-19-1")&&"v0"!=abtest_option_ab019_1||$("body").hasClass("hw-abt-31-1")&&"v0"!=abtest_option_ab031_1)&&$(".custom-variant-selector-wrapper").length>0?($(".hide-default-variant-selector").length>0?($("variant-selects").hide(),$('.custom-variant-selector-items[data-position="1"] input').first().prop("checked",!0).trigger("change")):($("variant-selects .custom-selector-name-quantite").hide(),$("variant-selects .product-form__input.product-form__input--dropdown").css("max-width","100%"),$("variant-selects .product-form__input.product-form__input--dropdown div.select").css("max-width","100%")),$(".guide-des-tailles").hide(),$(".custom-variant-selector-wrapper").show()):($("variant-selects").show(),$(".guide-des-tailles").show(),$(".custom-variant-selector-wrapper").hide(),$("variant-selects .custom-selector-name-quantite").removeAttr("style"),$("variant-selects .product-form__input.product-form__input--dropdown div.select").removeAttr("style")),$("body").hasClass("hw-abt-31-1")&&"v0"!=abtest_option_ab031_1&&$(".custom-vairant-quantity-box-wrapper .quantity__input").val()>1?($(".product-form__submit").attr("type","button"),$(".product-form__submit").addClass("custom-single-product-button custom-quick-add__submit")):($(".product-form__submit").attr("type","submit"),$(".product-form__submit").removeClass("custom-single-product-button custom-quick-add__submit"))):$("body").hasClass("hw-abt-31-1")&&$(".quick-add-modal .hide-default-variant-selector").length>0?($(".hide-default-variant-selector").length>0?($("variant-selects").hide(),$('.custom-variant-selector-items[data-position="1"] input').first().prop("checked",!0).trigger("change")):($("variant-selects .custom-selector-name-quantite").hide(),$("variant-selects .product-form__input.product-form__input--dropdown").css("max-width","100%"),$("variant-selects .product-form__input.product-form__input--dropdown div.select").css("max-width","100%")),$(".guide-des-tailles").hide(),$(".custom-variant-selector-wrapper").show()):($("variant-selects").show(),$(".guide-des-tailles").show(),$(".custom-variant-selector-wrapper").hide(),$("variant-selects .custom-selector-name-quantite").removeAttr("style"),$("variant-selects .product-form__input.product-form__input--dropdown div.select").removeAttr("style")))}function findVariantGroup(t){const e=$('.custom-variant-selector-items[data-position="1"] input:checked').val(),i=$('.custom-variant-selector-wrapper select[name="option-selector"]').val();return t.filter((t=>t.option1.match(e)&&t.option2==i))}function updateFixQuantityBoxPrice(t){$(".custom-option-quantity-selector .option-price").each((function(){const e=$(this).data("pricetext"),i=+$(this).data("priceunit"),o=+$(this).data("division"),s=+$(this).data("percantage");let r=t.price*i/o;if(s>0){r-=r*s/100}$(this).html(`${Shopify.formatMoney(r)} ${e}`)}))}window.onresize=function(t){if(window.innerWidth>=989)$("li.grid__item.usp_item").length>0&&($("li.grid__item").each((function(t){if((t+1)%4!=0&&$(this).hasClass("usp_item")){const t=$(this).clone();$(this).next("li.grid__item").length>0&&($(this).next("li.grid__item").after(t),$(this).remove())}})),isResizeedGrid=!0);else if($("li.grid__item.usp_item").length>0&&1==isResizeedGrid){var e=$("#product-grid"),i=e.children(".grid__item");i.sort((function(t,e){return parseInt($(t).data("index"))-parseInt($(e).data("index"))})),i.detach().appendTo(e)}$(".product_composition_wrapper .swiper-container").length>0&&(egswiperTiktok&&egswiperTiktok.destroy(),egswiperTiktok=new Swiper(".product_composition_wrapper .swiper-container",{direction:"horizontal",spaceBetween:20,slidesPerView:4,roundLengths:!0,clickable:!1,breakpoints:{991:{slidesPerView:1,loop:!0}},pagination:{el:".product_pagination",clickable:!0},navigation:{nextEl:".swiper-button-next",prevEl:".swiper-button-prev"}}))},$(document).on("click",".benefits-accordion_item summary",(function(t){t.preventDefault(),$(".benefits-accordion_item .accprdomg_main").not($(this).parent()).removeClass("active"),$(".benefits-accordion_item .accordion__content").not($(this).next()).slideUp(),$(this).parent().toggleClass("active"),$(this).next().slideToggle()})),change_checkoutbtn_text(),jQuery(document).ready((function(t){t(document).on("click",".custom-click-tigger-guide",(function(){const e=t(this).data("id");t(`modal-dialog[id="${e}"]`).length>0?t(`modal-dialog[id="${e}"]`).attr("open",!0):t(".guide-des-tailles button").length>0&&t(".guide-des-tailles button").trigger("click")})),t(document).on("change",'.custom-variant-selector-wrapper select[name="option-selector"]',(function(){t(this).parents(".custom-variant-selector-items").find(".selected-option-name").text(t(this).val());const e=JSON.parse(t(".custom-variant-template-data").html()),i=t(".custom-variant-selector-items.quantity-option input:checked").data("optionvalue"),o=t(this).val(),s=e.filter((t=>t.option1==i&&t.option2==o));if(console.log(s,"filteredVariants",i,o),s.length>0){const e=s[0];updateFixQuantityBoxPrice(e);const i=t(this).closest("form").find(".product-form__submit");i.removeAttr("disabled"),i.find(".custom-text-placement").text(i.data("addmessage")),t(".product-variant-id").val(e.id)}else{const e=t(this).closest("form").find(".product-form__submit");e.attr("disabled","disabled"),e.find(".custom-text-placement").text(e.data("soldoutmessage"))}if(document.querySelectorAll("product-single-bundle-form").length>0){const t=+document.querySelector(".custom-vairant-quantity-box-wrapper .quantity__input").value;document.querySelector("product-single-bundle-form").updateButtonState(t)}})),t(document).on("change",".custom-option-quantity-selector input",(function(){const e=t(this).val(),i=JSON.parse(t(".custom-variant-template-data").html()),o=t(this).data("optionvalue"),s=t('.custom-variant-selector-wrapper select[name="option-selector"]').val(),r=i.filter((t=>t.option1==o&&t.option2==s));if(console.log(r,"filteredVariants",o,s),r.length>0&&(r[0].compare_at_price>r[0].price?(t(".price__sale .price-item--sale.price-item--last").text(Shopify.formatMoney(r[0].price)),t(".price__sale .price-item--regular").text(Shopify.formatMoney(r[0].compare_at_price))):t(".price__sale .price-item--sale price-item--last").text(Shopify.formatMoney(r[0].price)),t(".product-variant-id").val(r[0].id)),t(".hide-default-variant-selector").length>0&&(e>1?("v1"==abtest_option_ab031_1&&1==window.location.pathname.includes("/products")||"test"==abtest_option_ab031_1&&t("body.hw-abt-31-1").length>0&&1==window.location.pathname.includes("/products"))&&(t(".product-form__submit").addClass("custom-single-product-button custom-quick-add__submit"),t(".product-form__submit").attr("type","button")):(t(".product-form__submit").removeClass("custom-single-product-button custom-quick-add__submit"),t(".product-form__submit").attr("type","submit")),document.querySelectorAll("product-single-bundle-form").length>0)){const t=+e;document.querySelector("product-single-bundle-form").updateButtonState(t)}})),t(document).on("change",".custom-color-swatch input",(function(){const e=t(this).val(),i=JSON.parse(t(".custom-variant-template-data").html()),o=t(".custom-variant-selector-items.quantity-option input:checked").val(),s=findVariantGroup(i);t(this).parents(".custom-variant-selector-items").find(".selected-option-name").text(e),t(".custom-option-quantity-selector").each((function(){const i=t(this);i.data("option")==e?i.removeClass("hidden"):i.addClass("hidden")})),t(`.custom-option-quantity-selector:not(.hidden) input[value="${o}"]`).prop("checked",!0).trigger("change");const r=t(this).parents(".custom-variant-selector-wrapper").find(".custom-option-quantity-selector").not(".hidden").length;if(t(this).parents(".custom-variant-selector-wrapper").find(".custom-variant-flex-quantity-items").attr("data-size",r),s.length>0){updateFixQuantityBoxPrice(s[0]);const e=t(this).closest("form").find(".product-form__submit");e.removeAttr("disabled"),e.find(".custom-text-placement").text(e.data("addmessage"))}else{const e=t(this).closest("form").find(".product-form__submit");e.attr("disabled","disabled"),e.find(".custom-text-placement").text(e.data("soldoutmessage"))}})),t(".custom-variant-selector-wrapper").length>0&&("v1"==abtest_option_ab019_1||"v1"==abtest_option_ab031_1?(t(".hide-default-variant-selector").length>0?t("variant-selects").hide():(t("variant-selects .custom-selector-name-quantite").hide(),t("variant-selects .product-form__input.product-form__input--dropdown").css("max-width","100%"),t("variant-selects .product-form__input.product-form__input--dropdown div.select").css("max-width","100%")),t(".guide-des-tailles").hide(),t('.custom-variant-selector-items[data-position="1"] input').first().prop("checked",!0).trigger("change")):t(".custom-variant-selector-wrapper").hide())}));